import React from "react";
import { Link, RouteComponentProps } from "react-router-dom";

import { DateTime } from "luxon";

import { apiPost } from "../../Api";
import { formatDateLocal, formatName } from "../../Utilities";
import withTitle, { IViewTitleProps } from "../withTitle";

import "../../schedule.css";
import "../viewer.css";

interface IFairLocationFairListViewState {
    searchResults?: { [date: string]: any[] };
    isLoading: boolean;
    error?: string;
}

class FairLocationFairListView extends React.Component<RouteComponentProps<any> & IViewTitleProps, IFairLocationFairListViewState> {
    constructor(props: Readonly<RouteComponentProps<any> & IViewTitleProps>) {
        super(props);

        this.state = {
            isLoading: false,
        };

        this.searchFairs = this.searchFairs.bind(this);
    }

    public componentDidMount() {
        this.searchFairs();
    }

    public render() {
        let results;

        if (this.state.isLoading) {
            results = <div className="lds-dual-ring spinner-center" />;
        }
        else if (this.state.error) {
            results = <span className="error-text">{this.state.error}</span>;
        }
        else if (this.state.searchResults && Object.keys(this.state.searchResults).length === 0) {
            results = <span>No health fairs found</span>;
        }
        else if (this.state.searchResults) {
            results = (
                <section className="info-block">
                    <header>
                        <h3>Results</h3>
                    </header>
                    {
                        Object.keys(this.state.searchResults).map(k => (
                            <section key={k} className="schedule-section">
                                <h3>{formatDateLocal(k)}</h3>
                                <ul>
                                    {
                                        this.state.searchResults![k].map(r => (
                                            <li key={r.scheduledDate + r.name}>
                                                <Link to={`/fairs/${r.id}`}>
                                                    <span>{r.name}</span>
                                                    <span className="small-text">{`${r.address.city}, ${r.address.state}`}</span>
                                                    <span className="small-text member-list">{r.members.map((m: any) => formatName(m.name)).join(", ")}</span>
                                                </Link>
                                            </li>
                                        ))
                                    }
                                </ul>
                            </section>
                        ))
                    }
                </section>
            );
        }

        return (
            <div className="viewer-root">
                {results}
            </div>
        );
    }

    private async searchFairs() {
        const companyId = this.props.match.params.id;
        if (!companyId) {
            this.setState({
                searchResults: {}
            });
            return;
        }

        this.setState({
            isLoading: true,
        })

        try {
            const results = await apiPost<any[]>("fairs/search", { companyId: companyId });

            const groups: { [time: string]: any[] } = {};
            results.forEach(r => {
                const date = DateTime.fromISO(r.scheduledDate);
                const dateString = date.toISODate();
                if (!groups[dateString]) {
                    groups[dateString] = [];
                }

                groups[dateString].push(r);
            });

            this.setState({
                error: undefined,
                isLoading: false,
                searchResults: groups
            });

        } catch (e) {
            this.setState({
                error: e.message,
                isLoading: false
            });
        }
    }
}

export default withTitle("Company's Health Fairs", FairLocationFairListView);
